<template>
    <footer class="sticky-footer bg-white fixed-bottom">
        <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span>Copyright &copy; Soul Tecnologia - 2026</span> | <span class="small text-right">V.1.2.1</span>
        </div>
        </div>
    </footer>
</template>

<script>
export default {}
</script>
<style>
.fixed-bottom {
    background: #F8F9FC!important;
    bottom: 0;
    width: 100%;
     z-index: 1;
}

.small {
    font-size: 0.9em;
}
</style>